import vuexStore from "@/store/customSaveStore";
import { processingLegalRecommendation } from "../../recommendation/legal/store";

export const datasubjectProcessingLegal = vuexStore({
  namespaced: true,
  path: "/datasubject-processing-legal",
  state: {
    editedDatasubject: null,
    editedDatasubjectProcessingLegal: null,
    ...processingLegalRecommendation.state,
  },
  getters: {
    editedDatasubject: (state) => state.editedDatasubject,
    editedDatasubjectProcessingLegal: (state) => state.editedDatasubjectProcessingLegal,
    ...processingLegalRecommendation.getters,
  },
  mutations: {
    editedDatasubject: (state, value) => {
      state.editedDatasubject = value;
    },
    editedDatasubjectProcessingLegal: (state, value) => {
      state.editedDatasubjectProcessingLegal = value;
    },
    ...processingLegalRecommendation.mutations,
  },

  actions: {
    ...processingLegalRecommendation.actions,
  },
});

// export const datasubjectProcessingPurpose = vuexStore({
//   namespaced: true,
//   path: "/datasubject-processing-purpose",
//   state: {
//     editedDatasubject: null,
//   },
//   getters: {
//     editedDatasubject: (state) => state.editedDatasubject,
//   },
//   mutations: {
//     editedDatasubject: (state, value) => {
//       state.editedDatasubject = value;
//     },
//   },

//   actions: {
//     addFromLibrary({ commit }, payload) {
//       commit("isUpdating", true);
//       try {
//         return rest.post("/datasubject-processing-purpose", payload);
//       } finally {
//         commit("isUpdating", false);
//       }
//     },
//   },
// });
